import appEvents from 'constants/appEvents.constant';
import appCONST from 'constants/app.constants';
import themes from 'constants/themes';

export default function loginFactory(
    $http,
    $state,
    $q,
    $rootScope,
    $window,
    authService,
    sessionService,
    userService,
    basketService,
    l10nService,
    localeService,
    ipCookie,
    themesService,
) {
    'ngInject';

            const availableServicesUrl = '/authorize/GetAvailableServices';
            const tokenUrl = appCONST && appCONST.serverUrl + '/token';

            if ($rootScope) {
                $rootScope.$on(appEvents.LOGOUT, function() {
                    authService.logout();
                });
            }

            if ($rootScope) {
                $rootScope.$on(appEvents.REDIRECT_TO_DEFAULT, goToDefaultRoute);
            }

            return {
                getToken,
                getAvailableServices,
                goToProfile,
                goToAdmin,
                isTripDetailsHashExeption,
                fetchDepartments,
                changeDepartment,
                fetchData,
                getLocalization,
                autoLogin,
                loginSSO,
                changeUserLanguage,
                fetchUserData,
            };

            function isTripDetailsHashExeption(url) {
                const params = url.split('/').slice(2);
                return (params[0] === 'trip' && params[2] === 'details' && (params[1].indexOf('-') !== -1));
            }

            function goToAdmin() {
                $http.post(tokenUrl, $.param(createRequestData()))
                    .then(({data: {access_token, refresh_token, expires_in}}) => { //eslint-disable-line camelcase
                        const requestToken = $.param({access_token}); //eslint-disable-line camelcase
                        authService.login(access_token, refresh_token, expires_in);
                        $rootScope.$broadcast(appEvents.REFRESH_TOKEN);

                        $window.location = appCONST.adminUrl + '?' + requestToken;
                    });
            }

            function goToProfile() {
                $.ajax(
                    {
                        method: 'POST',
                        url: tokenUrl,
                        data: $.param(createRequestData()),
                        success: function(response) {
                            if (response) {
                                const {access_token, refresh_token, expires_in} = response; //eslint-disable-line camelcase
                                const requestToken = $.param({token: access_token}); //eslint-disable-line camelcase
                                const location = appCONST.profileUrl + '?' + requestToken;

                                authService.login(access_token, refresh_token, expires_in);
                                $rootScope.$broadcast(appEvents.REFRESH_TOKEN);

                                $window.open(location, '_blank');
                            }
                        },
                        error: function() {
                            const requestToken = $.param({token: sessionService.getSessionItem('token')});
                            const location = appCONST.profileUrl + '?' + requestToken;

                            $window.open(location, '_blank');
                        },
                        // we use sync call, because browser blocks asynchronously open window
                        async: false,
                    }
                );
            }

            function getToken(userCredentials) {
                const requestData = {
                    username: userCredentials.user,
                    password: userCredentials.password,
                    grant_type: 'password', //eslint-disable-line camelcase
                    countryCode: userCredentials.countryCode,
                };

                if (userCredentials.contactPermissionId) {
                    requestData.contactPermissionId = userCredentials.contactPermissionId;
                }

                return $http.post(tokenUrl, $.param(requestData))
                    .then(processToken);
            }

            function createRequestData() {
                const refreshToken = getRefreshToken();
                return {
                    refresh_token: refreshToken, //eslint-disable-line camelcase
                    grant_type: 'refresh_token', //eslint-disable-line camelcase
                };
            }

            function getRefreshToken() {
                return sessionService.getSessionItem('refreshToken');
            }

            function processToken({data: {access_token, refresh_token, expires_in}}) { //eslint-disable-line camelcase
                authService.login(access_token, refresh_token, expires_in);
                return {
                    accessToken: access_token, //eslint-disable-line camelcase
                    refreshToken: refresh_token, //eslint-disable-line camelcase
                };
            }

            function getLocalization() {
                return $http.apiGET('/staticdata/GetAllLocalization')
                    .then((response) => response.data);
            }

            function getAvailableServices() {
                return $http.apiGET(availableServicesUrl)
                    .then(setCulture);
            }

            function setCulture({data}) {
                const culture = data.RegionalSettings.Culture;
                localeService.setWorkWeekByCulture(culture);
                return data;
            }

            function autoLogin(accessToken, refreshToken) {
                if (!accessToken || !refreshToken) {
                    return $state.go('login');
                }

                fetchData({accessToken, refreshToken})
                    .then(goToDefaultRoute);
            }

            function fetchUserData() {
                return $http.apiGET('/authorize/GetUserDetails')
                    .then(({data}) => data);
            }

            function fetchTranslations() {
                return l10nService.getAllTranslations();
            }

            function goToDefaultRoute() {
                $state.go('main.flights.roundtrip', {}, {reload: true});
            }

            function fetchData(tokens) {
                authService.login(tokens.accessToken, tokens.refreshToken);
                return $q.all({
                    user: fetchUserData(),
                    services: getAvailableServices(),
                }).then(({user, services}) => {
                    saveUserData(user);
                    authService.saveAvailableServices(services);

                    let theme = themes.default;
                    if (user.Theme && themes[user.Theme]) {
                        theme = themes[user.Theme];
                        ipCookie('userTheme', user.Theme, {expires: 100});
                    } else {
                        ipCookie('userTheme', '', {expires: 100});
                    }

                    themesService.applyTheme(theme);

                }).then(fetchTranslations)
                .then(goToDefaultRoute);
            }

            function saveUserData(userData) {
                authService.saveUser(userData);
            }

            function changeDepartment(department) {
                const requestParams = {
                    user: department.UserId,
                    password: department.Token,
                    grant_type: 'password', //eslint-disable-line camelcase
                    contactPermissionId: department.ContactPermissionId,
                    countryCode: department.CountryCode,
                };

                return getToken(requestParams)
                    .then(fetchUserData);
            }

            function fetchDepartments(loginData, forCurrentUser) {
                let requestData;
                if (!forCurrentUser) {
                    requestData = {
                        username: loginData.email,
                        password: loginData.password,
                        countryCode: 'uk',
                    };
                }

                const endpoint = forCurrentUser
                    ? '/authorize/GetCurrentUserDepartments'
                    : '/authorize/GetUserDepartments';

                return $http.apiPOST(endpoint, requestData, {noAuth: !forCurrentUser})
                    .then(({data}) => {

                        /**
                         * Save departments in persistent storage
                         * (to have ability retrieve departments after page refresh)
                         */
                        userService.saveUserDepartments(data);
                        return data;
                    });
            }
            function loginSSO(loginData) {
                return $http.apiGET('/Authorize/GetUserSingleSignOnConfiguration?email=' + loginData.emailSSO, {noAuth: true});
            }

            function changeUserLanguage(langCode) {
                const url = '/Authorize/UpdateUserCulture';
                return $http.apiPOST(url, angular.toJson(langCode));
            }

}



// WEBPACK FOOTER //
// ./src/app/modules/login/services/loginFactory.js